<div class="tab-pane fade active show" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab">
    <div class="card">
        <div class="card-header">
            <button class="btn btn-light collapse-toggle btn-sm" data-toggle="collapse"
                data-target="#personal-auto-insurance-content-collapse" aria-expanded="true"
                aria-controls="personal-auto-insurance-content-collapse">
                <span class="collapse-icon"></span>
            </button>Auto Insurance(s)
            <button type="button" class="btn btn-sm btn-primary float-right" data-toggle="collapse"
                data-target="#add-personal-auto-insurance-form-content-collapse" (click)="resetInformation()"
                title="Add" [disabled]="contactId == 0">
                Add
            </button>
        </div>
        <div class="collapse" id="add-personal-auto-insurance-form-content-collapse">
            <div class="card">
                @if (!policyInformation.get('id').value) {
                    <div class="card-header bg-light">
                        Add New Auto Insurance
                    </div>
                }
                <div class="card-body">
                    <form class="text-dark" [formGroup]="policyInformation">
                        <div class="row">
                            <div class="form-group col-md-6 col-sm-12">
                                <contact-advanced-search type="autoInsurance" (setContactId)="setContactIdEvent($event)"
                                    [contactIdSaved]="policyInformation.get('insuranceContactId').value"
                                    [contactNameSaved]="policyInformation.get('provider').value"></contact-advanced-search>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group col-md-3 col-sm-12">
                                <label for="policyNumber">Policy Number</label>
                                <input class="form-control text-dark" type="text" id="policyNumber"
                                    formControlName="policyNumber" autocomplete="off">
                            </div>
                            <div class="form-group col-md-3 col-sm-12">
                                <label for="effectiveFrom">Effective From</label>
                                <input class="form-control text-dark" type="date" id="effectiveFrom"
                                    formControlName="effectiveFrom" autocomplete="off">
                            </div>
                            <div class="form-group col-md-3 col-sm-12">
                                <label for="expiryDate">Expiry Date</label>
                                <input class="form-control text-dark" type="date" id="expiryDate"
                                    formControlName="expiryDate" autocomplete="off">
                            </div>
                        </div>
                    </form>
                </div>
                <div class="card-footer form-actions">
                    <button class="btn btn-link btn-sm" id="btn-cancel-personal-auto-insurance" data-toggle="collapse"
                        data-target="#add-personal-auto-insurance-form-content-collapse"><span class="text-danger">cancel</span></button>
                    <button class="btn btn-primary" (click)="savePersonalAutoInsurance()">Save</button>
                </div>
            </div>
        </div>
        <div class="collapse show" id="personal-auto-insurance-content-collapse">
            <div class="card-body">
                @if (policies.length>0) {
                <table class="table table-sm table-hover table-striped">
                    <thead>
                        <tr>
                            <th>Provider</th>
                            <th>Policy Number</th>
                            <th>Effective From</th>
                            <th>Expires</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (policy of policies; track policy.id) {
                        <tr>
                            <td>{{policy.provider}}</td>
                            <td>{{policy.policyNumber}}</td>
                            <td>{{policy.effectiveFrom | date:'E MMM d, yyyy'}}</td>
                            <td>{{policy.expiryDate | date:'E MMM d, yyyy'}}</td>
                            <td class="table-action">
                                <button data-toggle="collapse"
                                    data-target="#add-personal-auto-insurance-form-content-collapse"
                                    class="btn btn-sm btn-secondary" title="Edit"
                                    (click)="setInformation(policy)">Edit</button>
                                <button data-toggle="modal" title="Delete" data-target="#delete-personal-auto-insurance"
                                    (click)="setInformation(policy)"
                                    class="btn btn-sm btn-link"><span class="dripicons-trash text-danger"></span></button>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
                }
            </div>
        </div>
    </div>
</div>
<!-- delete modal -->
<div id="delete-personal-auto-insurance" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog"
    aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="uil-trash-alt text-danger h1"></span>
                <h4 class="text-danger w-100 text-center">{{ words[language][ 'delete' ] }}</h4>
                <span class="text-muted my-3 text-center">{{ words[language][ 'deletePersonalAutoInsurance' ] }}</span>

                <button class="btn btn-danger mt-2 mr-2" (click)="deletePersonalAutoInsurance()">
                    {{ words[language][ 'yes' ] }}
                </button>
                <button type="button" class="btn btn-secondary mt-2" data-dismiss="modal"
                    id="btn-cancel-personal-auto-insurance-delete">No</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->